import { FunctionComponent, useEffect, useState } from 'react';
import images from '../../assets/images';
import { clickedWorkshopDetails } from '../../pages/Workshop/Workshop';
import './JoinWorkshop.scss';
import { useAppSelector } from '../../redux/app/hooks';
import { ALERT_MESSAGE_ALREADY_IN_MEETING, ALERT_MESSAGE_TWO_USERS, CHIME, JITSI } from '../../utils/constants';
import { getIsJoinedLocalValue, hasUserAlreadyJoined } from '../../utils/helper';


interface PropsType{
    singleSessionDetail: clickedWorkshopDetails | undefined;
    setSingleSessionDetail: (val: clickedWorkshopDetails|undefined) => void;
    handleJoinMeeting: any;
    isTeacherButtonClicked: boolean;
    setIsTeacherButtonClicked: (val: boolean) => void;
}
const JoinWorkshop: FunctionComponent<PropsType> = ({ setIsTeacherButtonClicked, isTeacherButtonClicked, setSingleSessionDetail,handleJoinMeeting ,singleSessionDetail }) => {
    const {VideoConfGif} = images; 
    const { meetService } = useAppSelector((state) => state.auth);
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const [alreadyTwoUsersSameId, setAlreadyTwoUsersSameId] = useState<boolean>()
    const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;
    const isJoined = localStorage.getItem("isJoined") || '';
    const { isStartingMeeting } = useAppSelector((state) => state?.dashboard);
    
const handleClickJoinButton = () => {
    handleJoinMeeting();
}
const handleClickOkButton = () => {
    setSingleSessionDetail(undefined);
}

useEffect(()=>{
    const alreadyJoined = hasUserAlreadyJoined(singleSessionDetail?.participantIds || [], currentUserId);
    setAlreadyTwoUsersSameId(alreadyJoined)

},[singleSessionDetail?.participantIds])

useEffect(() => {
  console.log("isJoined changed:", isJoined);
  setIsTeacherButtonClicked(false);
}, [isJoined]);

console.log("single", isTeacherButtonClicked,  isJoined);
return (
    <div className='joinWorkshopMainContainer'>
        <div className='gifContainer' style={{gap: singleSessionDetail?.wsStatus === 'STARTED' ? "" : '6px'}}>
            <img src={VideoConfGif} alt='gif' className='gifStyle'/>
            <div className='textContainer'>
                <div className='mainTitleStyle'>
                    {
                            (singleSessionDetail?.wsStatus === 'NOT_STARTED'
                                ?
                                `Meeting Not Ready now`
                                :
                                singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount === 0
                                    ?
                                    `Session Completed`
                                    :
                                    singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0
                                        ?
                                        `Join Live meeting now`
                                        : ''
                            ) 
                    }
                </div>
                {
                    (singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0) ?
                    <>
                        <div className='topicContainerStyle'><div className='topicStyle'>{`Topic:`}</div> {singleSessionDetail?.wsTopic}</div>
                        <div className='subTitleStyle'>{`meeting is on going, click on the button below to join`}</div>
                    </>:
                    <></>
                }
            </div>
        </div>
        <div 
  className='ctaContainer' 
  onClick={
    meetService === JITSI
      ? ((singleSessionDetail?.wsStatus === 'STARTED') ? handleClickJoinButton : handleClickOkButton)
      : ((singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0) ? handleClickJoinButton : handleClickOkButton)
  }
  style={{
    pointerEvents: (isTeacherButtonClicked || (getIsJoinedLocalValue() === "joined") || (isStartingMeeting && (meetService === CHIME))) ? 'none' : 'unset',
    cursor: (isTeacherButtonClicked || (getIsJoinedLocalValue() === "joined") || (isStartingMeeting && (meetService === CHIME))) ? 'default' : 'pointer'
  }}
>
  
  <button
    className={`btnStyle ${alreadyTwoUsersSameId? "disabled": ""}`}
    disabled={alreadyTwoUsersSameId || (isStartingMeeting && (meetService === CHIME))} // 🔹 disable only when condition is true
  >
    {
      ((singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0) ? `Join` : 'Ok')
    }
  </button>
{alreadyTwoUsersSameId && (
    <span className='alert-msg'>
      {ALERT_MESSAGE_TWO_USERS}
    </span>
  )}
  {(!(getIsJoinedLocalValue() === "left" || getIsJoinedLocalValue() === '')) && !alreadyTwoUsersSameId && singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0 && (
      <span className='alreadyInMeeting'>
          {ALERT_MESSAGE_ALREADY_IN_MEETING}
      </span>
  )}
</div>

    </div>
  )
}

export default JoinWorkshop
